import { render, staticRenderFns } from "./DragVerify.vue?vue&type=template&id=7fb21756&scoped=true"
import script from "./DragVerify.vue?vue&type=script&lang=js"
export * from "./DragVerify.vue?vue&type=script&lang=js"
import style0 from "./DragVerify.vue?vue&type=style&index=0&id=7fb21756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb21756",
  null
  
)

export default component.exports